export const DASHBOARDSTATS = 'DASHBOARDSTATS';

export const dashboardstat = (stats: any) => ({
  type:DASHBOARDSTATS,
  payload: stats
});